import { FascicoloFull } from '../../../../common/models/fascicolo/fascicolo-full';
import { TipoRevocazione } from '../../../../common/models/tipologiche/tipo-revocazione';

export class FascicoloRevocazione extends FascicoloFull {
  sezione: string;
  sospensiva: boolean;
  esitoSospensiva: string;
  tipoRevocazione: TipoRevocazione;
  motivoRevocazione: string;
  proveFattiDedotti: string;
  constructor() {
    super();
    this.dataInizioFascicolo = + new Date();
  }
}
